<div class="gallery-container">
    <div class="status-tag" *ngIf="badge">{{ badge }}</div>

    <div class="grid-gallery">
        <img *ngFor="let img of previewImages"
             [src]="img.url"
             [alt]="img.name || 'Imagen de la propiedad'"
             (click)="openGallery()" />

    </div>

    <button *ngIf="hasMoreImages" (click)="openGallery()" class="btn-show-all">
        Ver más fotos +
    </button>
</div>
